/* Sets --etq-announcement-h to the announcement bar height,
   and flags the body so the first-section padding override can scope safely. */
(function () {
  function setOverlay() {
    var bar = document.querySelector('.announcement-bar-section, .utility-bar, .announcement-bar');
    var h = bar ? bar.offsetHeight : 0;
    document.documentElement.style.setProperty('--etq-announcement-h', h + 'px');
  }
  if (document.querySelector('.etq-header-overlay')) {
    document.body.classList.add('etq-header-overlay-active');
    setOverlay();
    window.addEventListener('resize', setOverlay);
    window.addEventListener('load', setOverlay);
  }
})();